module Omni.Booker {
    NgModule.component("omniBookerBookHeader", {
        bindings: {
            propertyDetail: "="    // Input
        },
        templateUrl: "omni-booker-book-header.html",
        controller: class OmniBookerHeaderController {
            // Bindings
            private propertyDetail;
            public opaqueBackground: boolean;

            static $inject = [
                "$log",
                "bookerConfig",
                "omni.bookingservice"
            ];
            constructor(
                private readonly $log: ng.ILogService,
                private readonly bookerConfig: Constants.IBookerConfiguration,
                private readonly bookingService: IBookingService
            ) {
                this.opaqueBackground = this.bookerConfig.IsBookerOpaque;
            }

            CloseBooker() {
                this.bookingService.CloseBooker();
            }
        }      
    });
}
